import React, { useState, useEffect } from "react"
import { useLocation, useNavigate, Link } from "react-router-dom"
import API from "./../../Util/API"
import Carousel from "react-bootstrap/Carousel"

export function CarouselComponent({ path, category }) {
	const [isLoaded, setIsLoaded] = useState(false)
	const [items, setItems] = useState([])
	const navigate = useNavigate()
	const api = API()

	useEffect(() => {
		api
			.get(path)
			.then((response) => {
				setIsLoaded(true)
				setItems(response)
			})
			.catch((error) => {
				console.error(error)
			})
	}, [])

	const navigateToPost = (item) => {
		navigate(`/post/${category}/${item.id}`)
	}

	return (
		<React.Fragment>
			{!isLoaded ? (
				<div className="d-flex flex-column align-items-center justify-content-center py-5" style={{ minHeight: "350px" }}>
					<div className="spinner-border text-primary" role="status" style={{ width: "2.5rem", height: "2.5rem" }}>
						<span className="visually-hidden">Carregando...</span>
					</div>
				</div>
			) : (
				<Carousel id="carousel-1" interval={6000} className="rounded-3 shadow-sm overflow-hidden">
					{items.map(
						(item) =>
							item.imageCover && (
								<Carousel.Item key={item.id} style={{ maxHeight: "500px", minHeight: "350px", backgroundColor: "#0f172a" }}>
									<img
										id="carouselImg"
										className="d-block w-100"
										src={item.imageCover}
										alt={item.title}
										onClick={() => navigateToPost(item)}
										style={{ objectFit: "cover", height: "450px", opacity: 0.65, cursor: "pointer" }}
									/>
									<Carousel.Caption className="text-center mb-3">
										<h3 className="h4 fw-bold text-white mb-2 text-truncate" style={{ textShadow: "0 2px 8px rgba(0, 0, 0, 0.85)" }}>
											{item.title}
										</h3>
										{item.abstract && (
											<p
												className="text-white small mb-0 mx-auto"
												style={{
													maxWidth: "700px",
													textShadow: "0 1px 6px rgba(0, 0, 0, 0.85)",
													display: "-webkit-box",
													WebkitLineClamp: 2,
													WebkitBoxOrient: "vertical",
													overflow: "hidden",
												}}
											>
												{item.abstract}
											</p>
										)}
									</Carousel.Caption>
								</Carousel.Item>
							),
					)}
				</Carousel>
			)}
		</React.Fragment>
	)
}
